import { Icon } from "@juiceforward/narrative-player";

interface NewNarrativeModalProps {
  onClose: () => void;
}

export const NewNarrativeModal = ({ onClose }: NewNarrativeModalProps) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-[var(--admin-surface)] border border-[var(--admin-border)] rounded-lg max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-[var(--admin-border)] flex items-center justify-between">
          <h2 className="text-xl font-semibold text-[var(--admin-text)]">
            New Narrative
          </h2>
          <button
            onClick={onClose}
            className="text-[var(--admin-text-muted)] hover:text-[var(--admin-text)] transition-colors"
          >
            <Icon icon="times" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-[var(--admin-text-muted)] mb-2">
              Narrative Title
            </label>
            <input
              type="text"
              placeholder="e.g., Q1 2026 Executive Summary"
              className="w-full bg-[var(--admin-input-bg)] border border-[var(--admin-border-secondary)] rounded-lg px-4 py-2.5 text-[var(--admin-text)] placeholder-[var(--admin-text-subtle)] focus:outline-none focus:border-emerald-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--admin-text-muted)] mb-2">
              Project Goals & Requirements
            </label>
            <textarea
              rows={4}
              placeholder="Describe the key goals, objectives, and requirements for this narrative..."
              className="w-full bg-[var(--admin-input-bg)] border border-[var(--admin-border-secondary)] rounded-lg px-4 py-2.5 text-[var(--admin-text)] placeholder-[var(--admin-text-subtle)] focus:outline-none focus:border-emerald-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--admin-text-muted)] mb-2">
              Design Direction
            </label>
            <textarea
              rows={3}
              placeholder="Describe the tone, style, and visual direction for this narrative..."
              className="w-full bg-[var(--admin-input-bg)] border border-[var(--admin-border-secondary)] rounded-lg px-4 py-2.5 text-[var(--admin-text)] placeholder-[var(--admin-text-subtle)] focus:outline-none focus:border-emerald-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--admin-text-muted)] mb-2">
              Target Audience
            </label>
            <input
              type="text"
              placeholder="e.g., C-Suite executives, Product managers"
              className="w-full bg-[var(--admin-input-bg)] border border-[var(--admin-border-secondary)] rounded-lg px-4 py-2.5 text-[var(--admin-text)] placeholder-[var(--admin-text-subtle)] focus:outline-none focus:border-emerald-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--admin-text-muted)] mb-2">
              Key Metrics to Highlight
            </label>
            <input
              type="text"
              placeholder="e.g., Revenue growth, Customer satisfaction, Usage trends"
              className="w-full bg-[var(--admin-input-bg)] border border-[var(--admin-border-secondary)] rounded-lg px-4 py-2.5 text-[var(--admin-text)] placeholder-[var(--admin-text-subtle)] focus:outline-none focus:border-emerald-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-[var(--admin-text-muted)] mb-2">
              Content Themes
            </label>
            <input
              type="text"
              placeholder="e.g., Success stories, Product updates, Strategic insights"
              className="w-full bg-[var(--admin-input-bg)] border border-[var(--admin-border-secondary)] rounded-lg px-4 py-2.5 text-[var(--admin-text)] placeholder-[var(--admin-text-subtle)] focus:outline-none focus:border-emerald-500"
            />
          </div>
        </div>
        <div className="p-6 border-t border-[var(--admin-border)] flex items-center gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[var(--admin-input-bg)] border border-[var(--admin-border-secondary)] hover:border-[var(--admin-text-muted)] rounded-lg transition-colors text-[var(--admin-text)]"
          >
            Cancel
          </button>
          <button className="px-4 py-2 bg-emerald-500 hover:bg-emerald-600 rounded-lg transition-colors text-white">
            Submit Narrative
          </button>
        </div>
      </div>
    </div>
  );
};
